import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({ name: 'CurrencyUSD' })
export class CurrencyUSDPipe implements PipeTransform {
    constructor(private currencyPipe: CurrencyPipe) { }

    transform(
        value: number | string | null | undefined,
        currencyCode: string = 'USD',
        displaySymbol: boolean = false,
        showDecimals: boolean = true
    ): string {
        if (value === null || value === undefined || value === '') return null;
        if (typeof value === 'string') return value;
        const digitsInfo = showDecimals ? '1.2-2' : '1.0-0';
        return this.currencyPipe.transform(value, currencyCode, displaySymbol ? 'symbol' : 'code', digitsInfo);
    }
}